import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom"; 
import {
  getSalesBook,
  enviarLibroVentasEmail,
  getEmpresasParaLibroVentas,
} from '../../controllers/api_invoices';
import { showClient, getClients, normalizeClientsResponse } from '../../controllers/api_clients';
import { createPreInvoice } from "../../controllers/api_pre_invoices";
import { encryptText } from '../../controllers/api';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import "datatables.net-dt/css/dataTables.dataTables.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "../../assets/styles/salesBook.css";
import JSZip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
//import { read, utils } from 'xlsx';
import XLSX from "xlsx-js-style";
import { formatDecimal, formatDate, formatDateTime, formatText, formatInteger } from "../../utils/formatters";
import Papa from 'papaparse';
import { tooltipBtn } from "../../utils/datatableTooltip";

window.JSZip = JSZip;
DataTable.use(DT);

function SalesBook({ title, type }) {
  const navigate = useNavigate();
  const [modalOpenInvoices, setModalOpenInvoices] = useState(false);
  const [Invoices, setInvoices] = useState(false);

  const [modalImportOpen, setModalImportOpen] = useState(false);
  const [preInvoicesToImport, setPreInvoicesToImport] = useState([]);
  const [filterType, setFilterType] = useState("");
  const [docTerceroFilter, setDocTerceroFilter] = useState("");
  // (2026-05-15) Terceros del emisor para el filtro como select.
  const [terceros, setTerceros] = useState([]);
  var responseCache = useState(false);
  const [showSummary, setShowSummary] = useState(null);

  // (2026-05-21) Estado para admin/auditor: filtro de empresa objetivo
  // del Libro de Ventas. Si la empresa seleccionada es emisor, se
  // cargan adicionalmente sus terceros vinculados para el sub-filtro.
  const [empresasSistema, setEmpresasSistema] = useState([]);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState("");
  const [empresaSelIsEmisor, setEmpresaSelIsEmisor] = useState(false);
  // Estado de envio del libro por correo (loading + ultimo destinatario).
  const [envioEnCurso, setEnvioEnCurso] = useState(false);

  const authData = localStorage.getItem("authData");
  const authclientId = authData ? JSON.parse(authData).empresa_id : null;
  const formattedDate = new Date().toISOString().split("T")[0];
  const rol = authData ? JSON.parse(authData)['rol'] : null;
  const esAdminOAuditor = rol === 'admin' || rol === 'auditor';

  // (2026-05-21) Carga inicial de terceros del usuario actual (operador)
  // o, si el usuario es admin/auditor con empresa seleccionada, los
  // terceros vinculados a esa empresa.
  useEffect(() => {
    (async () => {
      try {
        if (esAdminOAuditor && empresaSeleccionada) {
          if (empresaSelIsEmisor) {
            // Terceros de la empresa seleccionada (sub-empresas con padre_id).
            const resp = await getEmpresasParaLibroVentas({
              es_tercero: 'true',
              padre_id: empresaSeleccionada,
            });
            setTerceros(Array.isArray(resp) ? resp : (resp?.data || []));
          } else {
            // La empresa seleccionada no es emisor: no hay terceros.
            setTerceros([]);
          }
        } else {
          const resp = await getClients({ es_tercero: true });
          setTerceros(normalizeClientsResponse(resp) || []);
        }
      } catch (e) {
        setTerceros([]);
      }
    })();
  }, [empresaSeleccionada, empresaSelIsEmisor, esAdminOAuditor]);

  // (2026-05-21) Cargar empresas para el filtro admin/auditor.
  useEffect(() => {
    if (!esAdminOAuditor) return;
    (async () => {
      try {
        const data = await getEmpresasParaLibroVentas();
        const lista = Array.isArray(data) ? data : (data?.data || []);
        setEmpresasSistema(lista);
      } catch (e) {
        setEmpresasSistema([]);
      }
    })();
  }, [esAdminOAuditor]);

  // Cuando admin cambia la empresa, actualizamos el flag `es_emisor` y
  // limpiamos cualquier seleccion previa de tercero para evitar pasar un
  // tercero_id que no pertenece a la nueva empresa.
  const handleCambioEmpresa = (id) => {
    setEmpresaSeleccionada(id);
    const e = (empresasSistema || []).find((x) => String(x.id) === String(id));
    setEmpresaSelIsEmisor(!!(e && e.es_emisor));
    setDocTerceroFilter("");
    try {
      const $t = $("#filtro_tercero_id_lv");
      if ($t.length) $t.val("");
    } catch (_) {}
  };

  useEffect(() => {
    try {
      if ($.fn.dataTable.isDataTable('#ListSalesBookDt')) {
        const table = $("#ListSalesBookDt").DataTable();
        const isTercero = docTerceroFilter === 'true';
        table.column(3).visible(isTercero);
        table.column(4).visible(isTercero);
      }
    } catch (e) {}
  }, [docTerceroFilter]);

  const actionSearch = () => {
    const table = $("#ListSalesBookDt").DataTable();
    table.clear();
    table.search("");
    table.columns().search("");
    table.ajax.reload();
  };

  // Calcular sumatoria de las columnas numéricas de tableData
  const addTotalsRow = (tableData) => {
    if (!tableData.length) return tableData;

    // Obtener todas las claves de las columnas
    const columns = Object.keys(tableData[0]);

    // Creamos el objeto total
    const totalsRow = {};

    columns.forEach((key) => {
      // Si es la columna de "Total Ventas  Bs. Incluyendo IVA." o posteriores, sumamos
      if (key != 'Nro Oper.' && typeof tableData[0][key].v === "number") {
        totalsRow[key] = tableData.reduce((sum, row) => sum + Number(row[key].v || 0), 0);
      } else {
        totalsRow[key] = ""; // columnas de texto que no se suman
      }
    });
    return [...tableData, totalsRow];
  };

  // Agregar estilos a la fila de totales
  const styleTotalsRow = (totalsRow) => {
    const styledRow = {};
    Object.keys(totalsRow).forEach((key) => {
      const value = totalsRow[key];
      styledRow[key] = {
        v: value,
        t: typeof value === "number" ? "n" : "s",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right", vertical: "center" },
          numFmt: typeof value === "number" ? "#,##0.00" : undefined,
        },
      };
    });
    return styledRow;
  };

  const styleAmount = {
    numFmt: '#,##0.00',
    alignment: { horizontal: "right", vertical: "center" },
  };

  const buildFooterRows = (summary) => {
    const r = summary?.hoja_resumen || {};

    const styleHeader = {
      font: { bold: true, color: { rgb: "FFFFFFFF" } },
      alignment: { horizontal: "center", vertical: "center" },
      fill: { fgColor: { rgb: "FF112C55" } },
    };

    // Helper para generar celdas de título
    const trg = (value) => ({ v: value, t: "s", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "left", vertical: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } });
    const t = (value) => ({ v: value, t: "s", s: styleHeader });
    const ti = (value) => ({ v: value, t: "s", s: { font: { bold: true }, alignment: { horizontal: "left", vertical: "center" } } });

    // Helper para generar celdas numéricas
    const n = (value) => ({ v: Number(value || 0), t: "n", s: styleAmount });

    return [
      [],

      [trg("RESUMEN GENERAL")],

      [
        t("Concepto"), t(""), t(""), t(""), t(""), t(""),
        t("Base imponible"), t("Débito fiscal"), t("IVA retenido"), t("IGTF percibido")
      ],

      [
        ti("Total ventas internas no gravadas"), t(""), t(""), t(""), t(""), t(""),
        n(r.resumen_por_tipo?.['01-reg']?.ventas_exentas),
        n(0),
        n(0),
        n(0)
      ],

      [
        ti("Total nota de crédito no gravadas"), t(""), t(""), t(""), t(""), t(""),
        n(r.resumen_por_tipo?.['03-reg']?.ventas_exentas),
        n(0),
        n(0),
        n(0)
      ],

      [
        ti("Total nota de débito no gravadas"), t(""), t(""), t(""), t(""), t(""),
        n(r.resumen_por_tipo?.['02-reg']?.ventas_exentas),
        n(0),
        n(0),
        n(0)
      ],

      [
        ti(`Total ventas internas afectadas sólo alícuota general ${formatDecimal(r.alicuota_general)}%`), t(""), t(""), t(""), t(""), t(""),
        n(r.resumen_por_tipo?.['01-reg']?.base_imponible_general),
        n(r.resumen_por_tipo?.['01-reg']?.iva_general),
        n(r.resumen_por_tipo?.['01-reg']?.iva_retenido_general),
        n(r.total_igtf_percibido)
      ],

      [
        ti(`Total ventas internas afectadas sólo alícuota reducida ${formatDecimal(r.alicuota_reducida)}%`), t(""), t(""), t(""), t(""), t(""),
        n(r.resumen_por_tipo?.['01-reg']?.base_imponible_reducida),
        n(r.resumen_por_tipo?.['01-reg']?.iva_reducida),
        n(r.resumen_por_tipo?.['01-reg']?.iva_retenido_reducida),
        n(0.0)
      ],

      [
        ti(`Total ventas internas afectadas sólo alícuota adicional ${formatDecimal(r.alicuota_adicional)}%`), t(""), t(""), t(""), t(""), t(""),
        n(r.resumen_por_tipo?.['01-reg']?.base_imponible_adicional),
        n(r.resumen_por_tipo?.['01-reg']?.iva_adicional),
        n(r.resumen_por_tipo?.['01-reg']?.iva_retenido_adicional),
        n(0.0)
      ],

      [
        ti(`Total notas de crédito o devoluciones aplicadas en ventas ${formatDecimal(r.alicuota_general)}%`), t(""), t(""), t(""), t(""), t(""),
        n(r.resumen_por_tipo?.['03-reg']?.base_imponible_general),
        n(r.resumen_por_tipo?.['03-reg']?.iva_general),
        n(r.resumen_por_tipo?.['03-reg']?.iva_retenido_general),
        n(0.0)
      ],

      [
        ti(`Total notas de crédito o devoluciones aplicadas en ventas ${formatDecimal(r.alicuota_reducida)}%`), t(""), t(""), t(""), t(""), t(""),
        n(r.resumen_por_tipo?.['03-reg']?.base_imponible_reducida),
        n(r.resumen_por_tipo?.['03-reg']?.iva_reducida),
        n(r.resumen_por_tipo?.['03-reg']?.iva_retenido_reducida),
        n(0.0)
      ],

      [
        ti(`Total notas de crédito o devoluciones aplicadas en ventas ${formatDecimal(r.alicuota_adicional)}%`), t(""), t(""), t(""), t(""), t(""),
        n(r.resumen_por_tipo?.['03-reg']?.base_imponible_adicional),
        n(r.resumen_por_tipo?.['03-reg']?.iva_adicional),
        n(r.resumen_por_tipo?.['03-reg']?.iva_retenido_adicional),
        n(0.0)
      ],

      [
        ti(`Total notas de débito o recargos aplicadas en ventas ${formatDecimal(r.alicuota_general)}%`), t(""), t(""), t(""), t(""), t(""),
        n(r.resumen_por_tipo?.['02-reg']?.base_imponible_general),
        n(r.resumen_por_tipo?.['02-reg']?.iva_general),
        n(r.resumen_por_tipo?.['02-reg']?.iva_retenido_general),
        n(0.0)
      ],

      [
        ti(`Total notas de débito o recargos aplicadas en ventas ${formatDecimal(r.alicuota_reducida)}%`), t(""), t(""), t(""), t(""), t(""),
        n(r.resumen_por_tipo?.['02-reg']?.base_imponible_reducida),
        n(r.resumen_por_tipo?.['02-reg']?.iva_reducida),
        n(r.resumen_por_tipo?.['02-reg']?.iva_retenido_reducida),
        n(0.0)
      ],

      [
        ti(`Total notas de débito o recargos aplicadas en ventas ${formatDecimal(r.alicuota_adicional)}%`), t(""), t(""), t(""), t(""), t(""),
        n(r.resumen_por_tipo?.['02-reg']?.base_imponible_adicional),
        n(r.resumen_por_tipo?.['02-reg']?.iva_adicional),
        n(r.resumen_por_tipo?.['02-reg']?.iva_retenido_adicional),
        n(0.0)
      ],

      [
        trg("Total"), t(""), t(""), t(""), t(""), t(""),
        n(Number(r.ventas_internas_no_gravadas || 0.0) + Number(r.base_imponible_general || 0.0) + Number(r.base_imponible_reducida || 0.0) + Number(r.base_imponible_adicional || 0.0)),
        n(Number(r.iva_general || 0.0) + Number(r.iva_reducida || 0.0) + Number(r.iva_adicional || 0.0)),
        n(r.total_iva_retenido_periodo),
        n(r.total_igtf_percibido)
      ],
    ];
  };

  return (
    <div className="mx-auto w-full">
      <ToastContainer />
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12">
          <div className="relative bg-white flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            {/* Header */}
            <div className="rounded-t bg-white mb-0 px-6 py-6 flex justify-between items-center border-b">
              <h6 className="text-blueGray-700 text-xl font-bold">{title}</h6>
              <div className="flex items-center space-x-3">
                <div className="flex space-x-2 mb-3 flex-wrap items-center">
                  <h3 class="text-blueGray-700 font-bold me-3 my-3">Buscar por:</h3><br/>
                  {/* (2026-05-21) Filtro de empresa - solo admin/auditor */}
                  {esAdminOAuditor && (
                    <select
                      id="filtro_empresa_lv"
                      className="border p-2 rounded"
                      value={empresaSeleccionada}
                      onChange={(e) => handleCambioEmpresa(e.target.value)}
                      style={{ minWidth: "220px" }}
                      title="Filtrar libro por empresa especifica"
                    >
                      <option value="">Todas las empresas</option>
                      {(empresasSistema || []).map((emp) => (
                        <option key={emp.id} value={emp.id}>
                          {(emp.nombre_empresa || emp.denominacion_comercial || emp.rif || 'Empresa sin nombre')}
                          {(emp.rif && (emp.nombre_empresa || emp.denominacion_comercial)) ? ` (${emp.rif})` : ''}
                          {emp.es_emisor ? ' · Emisor' : ''}
                          {emp.es_tercero ? ' · Tercero' : ''}
                        </option>
                      ))}
                    </select>
                  )}
                  {/* SELECT PRINCIPAL */}
                  <select id="filter_type" className="border p-2 rounded" value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                    <option value="-"> - </option>
                    <option value="periodo">Período</option>
                    <option value="rango_fecha">Fecha</option>
                  </select>
                  {filterType === "periodo" && (
                    <input type="month" id="filtro_periodo" name="filtro_periodo"/>
                  )}
                  {filterType === "rango_fecha" && (
                    <>
                      <input id="filtro_desde" type="date" className="border p-2 rounded" />
                      <input id="filtro_hasta" type="date" className="border p-2 rounded" />
                    </>
                  )}
                  {/* (2026-05-13) Req1 P2: filtros adicionales de facturación a terceros */}
                  <select id="filtro_doc_tercero_lv" className="border p-2 rounded" value={docTerceroFilter} onChange={(e) => setDocTerceroFilter(e.target.value)}>
                    <option value="">Todos los docs.</option>
                    <option value="true">Solo doc. de tercero</option>
                    <option value="false">Solo doc. propios</option>
                  </select>
                  {docTerceroFilter === "true" && (
                    <select id="filtro_tercero_id_lv" className="border p-2 rounded" defaultValue="" style={{ minWidth: "180px" }}>
                      <option value="">Tercero (todos)</option>
                      {terceros.map((t) => (
                        <option key={t.id} value={t.id}>
                          {(t.nombre_empresa || t.denominacion_comercial || t.rif || 'Empresa sin nombre')}{(t.rif && (t.nombre_empresa || t.denominacion_comercial)) ? ` (${t.rif})` : ''}
                        </option>
                      ))}
                    </select>
                  )}
                  <button
                    className="bg-twilight-indigo-600 hover:bg-twilight-indigo-500 text-white font-bold py-2 px-4 rounded"
                    onClick={actionSearch}>
                    Buscar
                  </button>
                  {/* (2026-05-21) Enviar libro por correo. */}
                  <button
                    className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50"
                    disabled={envioEnCurso}
                    title="Enviar libro de ventas por correo al destinatario correspondiente"
                    onClick={async () => {
                      try {
                        // Construimos la query con los mismos filtros que usa
                        // el DataTable + el empresa_id si admin/auditor lo
                        // selecciono. El backend resuelve el destinatario.
                        const query = {};
                        if ($('#filter_type option:selected').val() === "periodo" && $("#filtro_periodo").val())
                          query.periodo = $("#filtro_periodo").val();
                        if ($('#filter_type option:selected').val() === "rango_fecha" && $('#filtro_desde').val() && $('#filtro_hasta').val()) {
                          query.desde = $('#filtro_desde').val();
                          query.hasta = $('#filtro_hasta').val();
                        }
                        const _docTero = $('#filtro_doc_tercero_lv option:selected').val();
                        if (_docTero) query.doc_tercero = _docTero;
                        const _terceroId = $('#filtro_tercero_id_lv').val();
                        if (_terceroId) query.tercero_id = _terceroId;
                        if (esAdminOAuditor && empresaSeleccionada) {
                          query.empresa_id = empresaSeleccionada;
                        }

                        // Validamos que haya algun filtro de periodo o rango
                        if (!query.periodo && !(query.desde && query.hasta)) {
                          toast.warning("Seleccione un periodo o rango de fechas antes de enviar.");
                          return;
                        }
                        // Mensaje opcional al destinatario
                        const mensaje = window.prompt(
                          "Mensaje opcional al destinatario (deje vacio para usar el mensaje estandar):",
                          ""
                        );
                        if (mensaje === null) return; // cancelado

                        setEnvioEnCurso(true);
                        // Disparamos la generacion del Excel usando la accion
                        // ya existente del DataTable (boton "Exportar todo
                        // (Excel)"), pero interceptamos el blob. Para evitar
                        // duplicar las ~250 lineas de construccion del libro,
                        // pedimos los datos y reutilizamos la accion del
                        // boton via un click programatico ligero. Si no hay
                        // datos para el periodo, el backend solo enviara un
                        // archivo vacio pero igual queda registrado el intento.

                        // Estrategia: obtenemos los datos directamente y los
                        // mandamos como un CSV simplificado si NO podemos
                        // re-usar XLSX aqui sin refactor mayor. Lo mas robusto
                        // es generar Excel inline:
                        const response = await getSalesBook(query);
                        if (!response || !response.hoja_detalle || response.hoja_detalle.length === 0) {
                          toast.warning("No hay operaciones para el periodo seleccionado.");
                          setEnvioEnCurso(false);
                          return;
                        }

                        // Construimos un Excel minimo pero serio:
                        // header + detalle. El resumen va al final con totales.
                        const wb = XLSX.utils.book_new();
                        const headerLibro = [
                          "Nro Oper.", "Fecha", "Tipo doc.", "Nro Factura",
                          "Nro Control", "Nro Comp. Retencion", "Factura afectada",
                          "Razon social", "RIF",
                          "Total con IVA", "Ventas exentas",
                          "Base Imp. (General)", "Alic. (General)", "IVA (General)",
                          "Base Imp. (Reducida)", "Alic. (Reducida)", "IVA (Reducida)",
                          "Base Imp. (Adicional)", "Alic. (Adicional)", "IVA (Adicional)",
                          "IVA Retenido", "IGTF Percibido"
                        ];
                        const rows = response.hoja_detalle.map((it) => [
                          it.nro_operacion,
                          it.fecha_documento,
                          it.tipo_transaccion,
                          it.numero_factura,
                          it.numero_control,
                          it.numero_comprobante_retencion,
                          it.numero_factura_afectada,
                          it.nombre_razon_social,
                          it.rif,
                          Number(it.total_ventas_con_iva || 0),
                          Number(it.ventas_exentas || 0),
                          Number(it.base_imponible_general || 0),
                          Number(it.alicuota_general || 0),
                          Number(it.iva_general || 0),
                          Number(it.base_imponible_reducida || 0),
                          Number(it.alicuota_reducida || 0),
                          Number(it.iva_reducida || 0),
                          Number(it.base_imponible_adicional || 0),
                          Number(it.alicuota_adicional || 0),
                          Number(it.iva_adicional || 0),
                          Number(it.iva_retenido || 0),
                          Number(it.igtf || 0),
                        ]);
                        const r = response.hoja_resumen || {};
                        const totales = [
                          "TOTAL", "", "", "", "", "", "", "", "",
                          "",
                          Number(r.ventas_internas_no_gravadas || 0),
                          Number(r.base_imponible_general || 0),
                          "",
                          Number(r.iva_general || 0),
                          Number(r.base_imponible_reducida || 0),
                          "",
                          Number(r.iva_reducida || 0),
                          Number(r.base_imponible_adicional || 0),
                          "",
                          Number(r.iva_adicional || 0),
                          Number(r.total_iva_retenido_periodo || 0),
                          Number(r.total_igtf_percibido || 0),
                        ];
                        const aoa = [
                          [`Libro de Ventas - ${query.periodo || (query.desde + ' al ' + query.hasta)}`],
                          [],
                          headerLibro,
                          ...rows,
                          totales,
                        ];
                        const ws = XLSX.utils.aoa_to_sheet(aoa);
                        XLSX.utils.book_append_sheet(wb, ws, "Libro de ventas");
                        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                        const blob = new Blob([wbout], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                        const filename = `Libro_de_ventas_${(query.periodo || formattedDate)}.xlsx`;

                        const res = await enviarLibroVentasEmail({
                          blob, filename, params: query, mensaje
                        });

                        if (res && res.exito) {
                          const dest = res.destinatario || '';
                          const nombre = res.destinatario_nombre || '';
                          const tipo = res.tipo_destinatario === 'tercero' ? 'tercero' : 'empresa';
                          toast.success(`Libro enviado al correo de ${tipo} '${nombre}' (${dest}).`);
                        } else {
                          toast.error(res?.mensaje || "Error al enviar el libro por correo.");
                        }
                      } catch (err) {
                        console.error("Error enviando libro:", err);
                        toast.error(err?.message || "Error inesperado al enviar el libro.");
                      } finally {
                        setEnvioEnCurso(false);
                      }
                    }}
                  >
                    <i className="fas fa-paper-plane mr-1"></i>
                    {envioEnCurso ? "Enviando..." : "Enviar por correo"}
                  </button>
                </div>
              </div>
            </div>

            {/* Tabla con scroll horizontal contenido en card */}
            <div className="w-full px-4 py-4 overflow-x-auto">
              <DataTable
                id="ListSalesBookDt"
                className="table-auto w-full text-left"
                columns={[
                  {
                    title: "Nro Oper.",
                    data: "nro_operacion",
                    className: "dt-center",
                    render: (data, type, row) => {
                      return formatInteger(data);
                    }
                  },
                  {
                    title: "Fecha de la factura",
                    data: "fecha_documento",
                    className: "dt-center",
                    render: (data, type, row) => {
                      return formatDate(data);
                    }
                  },
                  { title: "Tipo de documento", data: "tipo_transaccion", className: "dt-center", render: (data, type, row) => {
                      if (data == '01-reg'){
                        return formatText('Factura');
                      }else if (data == '02-reg'){
                        return formatText('Nota de Débito');
                      }else if (data == '03-reg'){
                        return formatText('Nota de Crédito');
                      }else if (data == '07-reg'){
                        return formatText('Retención');
                      }else{
                        return formatText(data);
                      }
                    }
                  },
                  // (2026-05-15) RIF y razón social del TERCERO al que
                  // pertenece la factura/retención (solo doc_tercero), justo
                  // después del Tipo de Documento.
                  { title: "RIF Tercero", data: "tercero_rif", visible: docTerceroFilter === "true", className: "dt-center", render: (data, type, row) => {
                      return data ? formatText(data) : '<span class="text-blueGray-400">—</span>';
                    }
                  },
                  { title: "Nombre Tercero", data: "tercero_nombre", visible: docTerceroFilter === "true", className: "dt-center", render: (data, type, row) => {
                      return data ? formatText(data) : '<span class="text-blueGray-400">—</span>';
                    }
                  },
                  { title: "Factura o Número de documento", data: "numero_factura", className: "dt-center", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  { title: "Número de control", data: "numero_control", className: "dt-center", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  { title: "N° comprobante", data: "numero_comprobante_retencion", className: "dt-center", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  { title: "Número factura afectada", data: "numero_factura_afectada", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  { title: "Nombre o razón social", data: "nombre_razon_social", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  { title: "RIF", data: "rif", className: "dt-center", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  {
                    title: "Total Ventas  Bs. Incluyendo IVA.",
                    data: "total_ventas_con_iva",
                    render: (data, type, row) => {
                      return formatDecimal(data);
                    }
                  },
                  ///VCT
                  {
                    title: " Ventas Internas No Gravadas",
                    data: "",
                    render: (data, type, row) => {
                      return formatDecimal(0.0);
                    }
                  },
                  {
                    title: " Base Imponible",
                    data: "",
                    render: (data, type, row) => {
                      return formatDecimal(0.0);
                    }
                  },
                  {
                    title: " % Alicuota",
                    data: "",
                    render: (data, type, row) => {
                      return formatDecimal(0.0);
                    }
                  },
                  {
                    title: " Impuesto I.V.A",
                    data: "",
                    render: (data, type, row) => {
                      return formatDecimal(0.0);
                    }
                  },
                  //C
                  {
                    title: "Ventas Internas No Gravadas",
                    data: "ventas_exentas",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) == 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: "Base Imponible",
                    data: "base_imponible_general",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) == 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: "% Alicuota General",
                    data: "alicuota_general",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) == 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: "Impuesto I.V.A",
                    data: "iva_general",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) == 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: "Base Imponible",
                    data: "base_imponible_reducida",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) == 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: "% Alicuota Reducida",
                    data: "alicuota_reducida",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) == 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: "Impuesto I.V.A",
                    data: "iva_reducida",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) == 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: "Base Imponible",
                    data: "base_imponible_adicional",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) == 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: "% Alicuota Adicional",
                    data: "alicuota_adicional",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) == 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: "Impuesto I.V.A",
                    data: "iva_adicional",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) == 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  //NC
                  {
                    title: " Ventas Internas No Gravadas",
                    data: "ventas_exentas",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) != 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: " Base Imponible",
                    data: "base_imponible_general",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) != 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: " % Alicuota General",
                    data: "alicuota_general",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) != 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: " Impuesto I.V.A",
                    data: "iva_general",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) != 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: " Base Imponible",
                    data: "base_imponible_reducida",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) != 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: " % Alicuota Reducida",
                    data: "alicuota_reducida",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) != 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: " Impuesto I.V.A",
                    data: "iva_reducida",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) != 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: " Base Imponible",
                    data: "base_imponible_adicional",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) != 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: " % Alicuota Adicional",
                    data: "alicuota_adicional",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) != 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: " Impuesto I.V.A",
                    data: "iva_adicional",
                    render: (data, type, row) => {
                      if ((row?.tipo_contribuyente?.id || 1) != 2){
                        return formatDecimal(data);
                      }else{
                        return formatDecimal(0.0);
                      }
                    }
                  },
                  {
                    title: "I.V.A Retenido",
                    data: "iva_retenido",
                    render: (data, type, row) => {
                      return formatDecimal(data);
                    }
                  },
                  {
                    title: "I.G.T.F Percibido",
                    data: "igtf",
                    render: (data, type, row) => {
                      return formatDecimal(data);
                    }
                  },
                ]}
                options={{
                  dom: //B = Buttons, l = LengthMenu (mostrar X registros), f = Filtro (search), t = Tabla, i = Info (mostrando de X a Y de Z), p = Paginación
                    "<'row'<'col-sm-12 text-start'B>>" +                // Fila 2: botones ocupando todo el ancho
                    "<'row'<'col-sm-6 text-end'l><'col-sm-6 py-5'f>>" +    // Fila 1: lengthMenu izquierda, filtro derecha
                    "<'row'<'col-sm-12'rt>>" +               // Fila 3: tabla
                    "<'row'<'col-sm-5 text-start'i><'col-sm-7 text-end'p>>",     // Fila 4: info izquierda, paginación derecha
                  /*dom:
                    "<'row'<'col-sm-12 text-start'B>>" +
                    "<'row'<'col-sm-6'l><'col-sm-6'f>>" +
                    "<'row'<'col-sm-12'rt>>" +
                    "<'row'<'col-sm-5'i><'col-sm-7'p>>",*/
                  serverSide: true, // si es true la paginación se debe controlar a traves del servidor
                  searching: true,
                  processing: true,
                  //scrollX: true,
                  scrollCollapse: true,
                  autoWidth: false,
                  paging: false,
                  //fixedHeader: true,
                  pageLength: 20,         // cantidad inicial por página
                  lengthMenu: [20, 50, 100], // opciones en el desplegable, false para oculta el selector
                  buttons: [
                    {
                      extend: "collection",
                      text: "Exportar",
                      className: "bg-slate-700 hover:bg-slate-600 text-white font-bold py-2 px-4 rounded",
                      buttons: [
                        /*{
                          extend: "pdfHtml5",
                          text: "PDF",
                          title: "Libro de ventas",
                          filename: "Libro_de_ventas",
                          exportOptions: {
                            columns: ':not(.no-export)'
                          },
                          orientation: "landscape",
                          //orientation: "landscape",   // opcional
                          //pageSize: "A4"              // opcional
                        },
                        {
                          extend: "print",
                          text: "Imprimir",
                          title: "Libro de ventas",
                          exportOptions: {
                            columns: ':not(.no-export)'
                          }
                        },*/
                        {
                          text: "Excel",
                          exportOptions: {
                            columns: ':not(.no-export)'
                          },
                          action: async function (e, dt, node, config) {
                            const exportButton = node;
                            try {
                              $(exportButton).text("Cargando...").prop("disabled", true).css("pointer-events", "none");

                              const query = {};
                              if ($('#filter_type option:selected').val() === "periodo" && $("#filtro_periodo").val())
                                query.periodo = $("#filtro_periodo").val();
                              if ($('#filter_type option:selected').val() === "rango_fecha" && $('#filtro_desde').val() && $('#filtro_hasta').val()) {
                                query.desde = $('#filtro_desde').val();
                                query.hasta = $('#filtro_hasta').val();
                              }
                              // (2026-05-15) Bug fix: la EXPORTACION omitia los
                              // filtros de tercero, por lo que "Solo doc.
                              // propios" exportaba igual la factura de tercero.
                              // Se replican los mismos filtros que la vista.
                              const _docTerceroLvX = $('#filtro_doc_tercero_lv option:selected').val();
                              if (_docTerceroLvX !== '' && _docTerceroLvX !== undefined)
                                query.doc_tercero = _docTerceroLvX;
                              const _terceroIdLvX = $('#filtro_tercero_id_lv').val();
                              if (_terceroIdLvX) query.tercero_id = _terceroIdLvX;
                              // (2026-05-21) Filtro empresa - admin/auditor.
                              if (esAdminOAuditor && empresaSeleccionada) {
                                query.empresa_id = empresaSeleccionada;
                              }

                              const isTercero = query.doc_tercero === 'true';
                              const offset = isTercero ? 2 : 0;

                              const response = await getSalesBook(query);
                              const { hoja_detalle, hoja_resumen } = response;
                              if (hoja_detalle.length > 0){
                                const responseClient = await showClient(authclientId);
                                const wb = XLSX.utils.book_new();
                                const ws = XLSX.utils.aoa_to_sheet([]);

                                // ---------------------------
                                // Header
                                // ---------------------------
                                const headerRows = [
                                  [{ v: formatText(responseClient.nombre_empresa), s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, fill: { fgColor: { rgb: "FF112C55" } }, alignment: { horizontal: "left", vertical: "center" } } }],
                                  [{ v: formatText(responseClient.rif), s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, fill: { fgColor: { rgb: "FF112C55" } } } }],
                                  [{ v: `Libro de ventas: ${query.periodo || `${query.desde} al ${query.hasta}`}`, s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, fill: { fgColor: { rgb: "FF112C55" } } } }],
                                  [], // línea en blanco
                                  [
                                    { v: "", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } } } },
                                    { v: "Ventas por cuentas de terceros", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Contribuyente", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "No contribuyente", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } } } },
                                  ],
                                  [
                                    { v: "Nro Oper.", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Fecha de la factura", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Tipo de documento", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Factura o Número de documento", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Número de control", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "N° comprobante", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Número factura afectada", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Nombre o razón social", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "RIF", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Total Ventas  Bs. Incluyendo IVA.", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Ventas Internas No Gravadas", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Base Imponible", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "% Alicuota", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Impuesto I.V.A", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Ventas Internas No Gravadas", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Base Imponible (General)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "% Alicuota (General)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Impuesto I.V.A (General)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Base Imponible (Reducida)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "% Alicuota (Reducida)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Impuesto I.V.A (Reducida)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Base Imponible (Adicional)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "% Alicuota (Adicional)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Impuesto I.V.A (Adicional)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Ventas Internas No Gravadas", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Base Imponible (General)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "% Alicuota (General)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Impuesto I.V.A (General)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Base Imponible (Reducida)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "% Alicuota (Reducida)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Impuesto I.V.A (Reducida)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Base Imponible (Adicional)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "% Alicuota (Adicional)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Impuesto I.V.A (Adicional)", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "I.V.A Retenido", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "I.G.T.F Percibido", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                  ]
                                ];
                                XLSX.utils.sheet_add_aoa(ws, headerRows, { origin: "A1" });
                                // Ahora agregamos los títulos de las agrupaciones
                                if (isTercero) {
                                  headerRows[5].splice(3, 0,
                                    { v: "RIF Tercero", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } },
                                    { v: "Nombre Tercero", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center" }, fill: { fgColor: { rgb: "FF112C55" } } } }
                                  );
                                }
                                XLSX.utils.sheet_add_aoa(ws, headerRows, { origin: "A1" });
                                
                                ws[XLSX.utils.encode_cell({c: 10 + offset, r: 4})] = {
                                  v: "Ventas por cuentas de terceros", t: "s", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center", vertical: "center" }, fill: { fgColor: { rgb: "FF112C55" } } }
                                };
                                ws[XLSX.utils.encode_cell({c: 14 + offset, r: 4})] = {
                                  v: "Contribuyente", t: "s", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center", vertical: "center" }, fill: { fgColor: { rgb: "FF112C55" } } }
                                };
                                ws[XLSX.utils.encode_cell({c: 24 + offset, r: 4})] = {
                                  v: "No contribuyente", t: "s", s: { font: { bold: true, color: { rgb: "FFFFFFFF" } }, alignment: { horizontal: "center", vertical: "center" }, fill: { fgColor: { rgb: "FF112C55" } } }
                                };

                                // ---------------------------
                                // Tabla detalle
                                // ---------------------------
                                const tableData = hoja_detalle.map(item => {
                                  const row = {
                                    "Nro Oper.": { v: Number(item.nro_operacion || 0), t: "n", s: { numFmt: '#0', alignment: { horizontal: "right", vertical: "center" } } },
                                    "Fecha de la factura": { v: new Date(item.fecha_documento), t: "d", s: { alignment: { horizontal: "center", vertical: "center" } } },
                                    "Tipo de documento": { v: (item.tipo_transaccion == '01-reg' ?
                                      formatText('Factura'):(item.tipo_transaccion == '02-reg' ?
                                       formatText('Nota de Débito'):(item.tipo_transaccion == '03-reg' ?
                                        formatText('Nota de Crédito'):(item.tipo_transaccion == '07-reg' ?
                                         formatText('Retención'):formatText(item.tipo_transaccion))))), t: "s", s: { alignment: { horizontal: "center", vertical: "center" } } }
                                  };
                                  if (isTercero) {
                                    row["RIF Tercero"] = { v: formatText(item.tercero_rif || ""), t: "s", s: { alignment: { horizontal: "center", vertical: "center" } } };
                                    row["Nombre Tercero"] = { v: formatText(item.tercero_nombre || ""), t: "s", s: { alignment: { horizontal: "left", vertical: "center" } } };
                                  }
                                  return Object.assign(row, {
                                    "Factura o Número de documento": { v: formatText(item.numero_factura), t: "s", s: { alignment: { horizontal: "center", vertical: "center" } } },
                                    "Número de control": { v: formatText(item.numero_control), t: "s", s: { alignment: { horizontal: "center", vertical: "center" } } },
                                    "N° comprobante": { v: formatText(item.numero_comprobante_retencion), t: "s", s: { alignment: { horizontal: "center", vertical: "center" } } },
                                    "Número factura afectada": { v: formatText(item.numero_factura_afectada), t: "s", s: { alignment: { horizontal: "center", vertical: "center" } } },
                                    "Nombre o razón social": { v: formatText(item.nombre_razon_social), t: "s", s: { alignment: { horizontal: "left", vertical: "center" } } },
                                    "RIF": { v: formatText(item.rif), t: "s", s: { alignment: { horizontal: "center", vertical: "center" } } },
                                    "Total Ventas  Bs. Incluyendo IVA.": { v: Number(item.total_ventas_con_iva || 0), t: "n", s: styleAmount },

                                    // VCT
                                    "VCT - Ventas Internas No Gravadas": { v: 0, t: "n", s: styleAmount },
                                    "VCT - Base Imponible": { v: 0, t: "n", s: styleAmount },
                                    "VCT - % Alicuota": { v: 0, t: "n", s: styleAmount },
                                    "VCT - Impuesto I.V.A": { v: 0, t: "n", s: styleAmount },

                                    // CONTRIBUYENTE
                                    "C - Ventas Internas No Gravadas": { v: Number((((item?.tipo_contribuyente?.id || 1) == 2) ? item.ventas_exentas : 0) || 0), t: "n", s: styleAmount },
                                    "C - Base Imponible (General)": { v: Number((((item?.tipo_contribuyente?.id || 1) == 2) ? item.base_imponible_general : 0) || 0), t: "n", s: styleAmount },
                                    "C - % Alicuota (General)": { v: Number((((item?.tipo_contribuyente?.id || 1) == 2) ? item.alicuota_general : 0) || 0), t: "n" },
                                    "C - Impuesto I.V.A (General)": { v: Number((((item?.tipo_contribuyente?.id || 1) == 2) ? item.iva_general : 0) || 0), t: "n", s: styleAmount },

                                    "C - Base Imponible (Reducida)": { v: Number((((item?.tipo_contribuyente?.id || 1) == 2) ? item.base_imponible_reducida : 0) || 0), t: "n", s: styleAmount },
                                    "C - % Alicuota (Reducida)": { v: Number((((item?.tipo_contribuyente?.id || 1) == 2) ? item.alicuota_reducida : 0) || 0), t: "n" },
                                    "C - Impuesto I.V.A (Reducida)": { v: Number((((item?.tipo_contribuyente?.id || 1) == 2) ? item.iva_reducida : 0) || 0), t: "n", s: styleAmount },

                                    "C - Base Imponible (Adicional)": { v: Number((((item?.tipo_contribuyente?.id || 1) == 2) ? item.base_imponible_adicional : 0) || 0), t: "n", s: styleAmount },
                                    "C - % Alicuota (Adicional)": { v: Number((((item?.tipo_contribuyente?.id || 1) == 2) ? item.alicuota_adicional : 0) || 0), t: "n" },
                                    "C - Impuesto I.V.A (Adicional)": { v: Number((((item?.tipo_contribuyente?.id || 1) == 2) ? item.iva_adicional : 0) || 0), t: "n", s: styleAmount },

                                    // NO CONTRIBUYENTE
                                    "NC - Ventas Internas No Gravadas": { v: Number((((item?.tipo_contribuyente?.id || 1) != 2) ? item.ventas_exentas : 0) || 0), t: "n", s: styleAmount },
                                    "NC - Base Imponible (General)": { v: Number((((item?.tipo_contribuyente?.id || 1) != 2) ? item.base_imponible_general : 0) || 0), t: "n", s: styleAmount },
                                    "NC - % Alicuota (General)": { v: Number((((item?.tipo_contribuyente?.id || 1) != 2) ? item.alicuota_general : 0) || 0), t: "n" },
                                    "NC - Impuesto I.V.A (General)": { v: Number((((item?.tipo_contribuyente?.id || 1) != 2) ? item.iva_general : 0) || 0), t: "n", s: styleAmount },

                                    "NC - Base Imponible (Reducida)": { v: Number((((item?.tipo_contribuyente?.id || 1) != 2) ? item.base_imponible_reducida : 0) || 0), t: "n", s: styleAmount },
                                    "NC - % Alicuota (Reducida)": { v: Number((((item?.tipo_contribuyente?.id || 1) != 2) ? item.alicuota_reducida : 0) || 0), t: "n" },
                                    "NC - Impuesto I.V.A (Reducida)": { v: Number((((item?.tipo_contribuyente?.id || 1) != 2) ? item.iva_reducida : 0) || 0), t: "n", s: styleAmount },

                                    "NC - Base Imponible (Adicional)": { v: Number((((item?.tipo_contribuyente?.id || 1) != 2) ? item.base_imponible_adicional : 0) || 0), t: "n", s: styleAmount },
                                    "NC - % Alicuota (Adicional)": { v: Number((((item?.tipo_contribuyente?.id || 1) != 2) ? item.alicuota_adicional : 0) || 0), t: "n" },
                                    "NC - Impuesto I.V.A (Adicional)": { v: Number((((item?.tipo_contribuyente?.id || 1) != 2) ? item.iva_adicional : 0) || 0), t: "n", s: styleAmount },

                                    "I.V.A Retenido": { v: Number(item.iva_retenido || 0), t: "n", s: styleAmount },
                                    "I.G.T.F Percibido": { v: Number(item.igtf || 0), t: "n", s: styleAmount }
                                  });
                                });

                                // Sumatoria de lineas:
                                const tableDataWithTotals = addTotalsRow(tableData).map((row, index, arr) => {
                                  // Solo estilizamos la última fila (la de totales)
                                  if (index === arr.length - 1) {
                                    return styleTotalsRow(row);
                                  }
                                  return row; // las demás filas se mantienen igual
                                });
                                XLSX.utils.sheet_add_json(ws, tableDataWithTotals, { origin: "A7", skipHeader: true });

                                // ---------------------------
                                // Footer
                                // ---------------------------
                                const footerStartRow = tableData.length + headerRows.length + 3;
                                const footerRows = buildFooterRows(response);
                                XLSX.utils.sheet_add_aoa(ws, footerRows, { origin: `A${footerStartRow}` });

                                // ---------------------------
                                // Merges
                                // ---------------------------
                                ws["!merges"] = [
                                  // ---------------------------
                                  // Header / agrupaciones
                                  // ---------------------------
                                  { s: { r: 0, c: 0 }, e: { r: 0, c: 6 + offset } },   // Cabecera L1
                                  { s: { r: 1, c: 0 }, e: { r: 1, c: 6 + offset } },   // Cabecera L2
                                  { s: { r: 2, c: 0 }, e: { r: 2, c: 6 + offset } },   // Cabecera L3
                                  { s: { r: 4, c: 0 }, e: { r: 4, c: 9 + offset } },   // Datos principales
                                  { s: { r: 4, c: 10 + offset }, e: { r: 4, c: 13 + offset } }, // VCT
                                  { s: { r: 4, c: 14 + offset }, e: { r: 4, c: 23 + offset } }, // Contribuyente
                                  { s: { r: 4, c: 24 + offset }, e: { r: 4, c: 33 + offset } }, // No contribuyente
                                  { s: { r: 4, c: 34 + offset }, e: { r: 4, c: 35 + offset } },  // Finales
                                  // ---------------------------
                                  // Footer / resumen
                                  // ---------------------------
                                  { s: { r: footerStartRow, c: 0 }, e: { r: footerStartRow, c: 9 } },   // Resumen General
                                  { s: { r: footerStartRow + 1, c: 0 }, e: { r: footerStartRow + 1, c: 5 } }, // Titulos
                                  { s: { r: footerStartRow + 2, c: 0 }, e: { r: footerStartRow + 2, c: 5 } }, // Total ventas internas no gravadas
                                  { s: { r: footerStartRow + 3, c: 0 }, e: { r: footerStartRow + 3, c: 5 } }, // Total nota de crédito no gravadas
                                  { s: { r: footerStartRow + 4, c: 0 }, e: { r: footerStartRow + 4, c: 5 } }, // Total nota de débito no gravadas
                                  { s: { r: footerStartRow + 5, c: 0 }, e: { r: footerStartRow + 5, c: 5 } }, // Total ventas internas afectadas sólo alícuota general 16%
                                  { s: { r: footerStartRow + 6, c: 0 }, e: { r: footerStartRow + 6, c: 5 } }, // Total ventas internas afectadas sólo alícuota reducida 8%
                                  { s: { r: footerStartRow + 7, c: 0 }, e: { r: footerStartRow + 7, c: 5 } }, // Total ventas internas afectadas sólo alícuota adicional 31%
                                  { s: { r: footerStartRow + 8, c: 0 }, e: { r: footerStartRow + 8, c: 5 } }, // Total notas de crédito o devoluciones aplicadas en ventas 16%
                                  { s: { r: footerStartRow + 9, c: 0 }, e: { r: footerStartRow + 9, c: 5 } }, // Total notas de crédito o devoluciones aplicadas en ventas 8%
                                  { s: { r: footerStartRow + 10, c: 0 }, e: { r: footerStartRow + 10, c: 5 } }, // Total notas de crédito o devoluciones aplicadas en ventas 31%
                                  { s: { r: footerStartRow + 11, c: 0 }, e: { r: footerStartRow + 11, c: 5 } }, // Total notas de débito o recargos aplicadas en ventas 16%
                                  { s: { r: footerStartRow + 12, c: 0 }, e: { r: footerStartRow + 12, c: 5 } }, // Total notas de débito o recargos aplicadas en ventas 8%
                                  { s: { r: footerStartRow + 13, c: 0 }, e: { r: footerStartRow + 13, c: 5 } }, // Total notas de débito o recargos aplicadas en ventas 31%
                                  { s: { r: footerStartRow + 14, c: 0 }, e: { r: footerStartRow + 14, c: 5 } }, // Total
                                ];

                                XLSX.utils.book_append_sheet(wb, ws, "Libro de ventas");

                                const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                                const blob = new Blob([wbout], { type: "application/octet-stream" });
                                const link = document.createElement("a");
                                link.href = URL.createObjectURL(blob);
                                link.download = `Libro_de_ventas_${formatDate(new Date())}.xlsx`;
                                link.click();

                                $(exportButton).text("Excel").prop("disabled", false).css("pointer-events", "auto");
                                toast.success("Archivo exportado correctamente.");
                              }else{
                                toast.warning("No hay operaciones que exportar.");
                              }
                            } catch (error) {
                              $(exportButton).text("Exportar todo (Excel)").prop("disabled", false).css("pointer-events", "auto");
                              console.error("Error al exportar:", error);
                              toast.error("Error al exportar los datos.");
                            }
                          }
                        }
                      ]
                    }
                  ],
                  language: {
                    decimal: ",",
                    thousands: ".",
                    lengthMenu: "Mostrar _MENU_ registros por página",
                    zeroRecords: "No se encontraron resultados",
                    info: "Mostrando de _START_ a _END_ de _TOTAL_ registros",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrado de _MAX_ registros totales)",
                    search: "Buscar:",
                    paginate: {
                      first: "Primero",
                      last: "Último",
                      next: "Siguiente",
                      previous: "Anterior"
                    }
                  },
                  ajax: async (dataTablesParams, callback) => {
                    try {
                      /*const page = Math.floor(params.start / params.length) + 1;
                      const per_page = params.length;
                      const response = await getInvoices({ page, per_page });*/
                      const searchValue = dataTablesParams.search?.value?.toLowerCase() || '';
                      //console.log('searchValue: ', searchValue);
                      // DataTables usa start y length, los convertimos a page y per_page
                      const query = {};
                      // Añadir filtros según filtro activo
                      if ($('#filter_type option:selected').val() === "periodo" && $("#filtro_periodo").val())
                        query.periodo = $("#filtro_periodo").val();

                      if ($('#filter_type option:selected').val() === "rango_fecha" && $('#filtro_desde').val() && $('#filtro_hasta').val()) {
                        query.desde = $('#filtro_desde').val();
                        query.hasta = $('#filtro_hasta').val();
                      }
                      // (2026-05-13) Req1 P2: filtros opcionales de facturación a terceros
                      const _docTerceroLv = $('#filtro_doc_tercero_lv option:selected').val();
                      if (_docTerceroLv) query.doc_tercero = _docTerceroLv;
                      const _terceroIdLv = $('#filtro_tercero_id_lv').val();
                      if (_terceroIdLv) query.tercero_id = _terceroIdLv;
                      // (2026-05-21) Filtro empresa - admin/auditor.
                      if (esAdminOAuditor && empresaSeleccionada) {
                        query.empresa_id = empresaSeleccionada;
                      }
                      if (searchValue == ''){
                        //console.log('if');
                        // Pasamos los filtros al servicio
                        const response = $('#filter_type option:selected').val() != '-' ? await getSalesBook(query) : [];
                        //console.log('response: ', response);
                        // Respaldar response anterior
                        if (response.error == undefined){
                          responseCache = response;
                          setShowSummary(response);
                        }else{
                          response.hoja_detalle = [];
                          responseCache = response;
                          setShowSummary(response);
                        }

                        // Aseguramos que la estructura esperada esté presente
                        var { hoja_detalle, hoja_resumen } = response;
                      }else{
                        //console.log('else');
                        const CAMPOS_EXCLUIDOS = [
                          "created_at",
                          "updated_at"
                        ];
                        //console.log('responseCache: ', responseCache);
                        var filteredData = responseCache.hoja_detalle.filter(item =>
                          Object.entries(item).some(([key, value]) => {
                            // Excluir campos internos
                            if (CAMPOS_EXCLUIDOS.includes(key)) return false;

                            if (!value) return false;

                            // Si es campo de fecha
                            if (key.includes("fecha_documento")) {
                              /*console.log('fecha_documento: ', value);
                              console.log('searchValue: ', searchValue);
                              console.log('formatDate: ', formatDate(value));*/
                              return formatDate(value).includes(searchValue.toUpperCase());
                            }

                            return String(value).toUpperCase().includes(searchValue.toUpperCase());
                          })
                        );
                        //console.log('filteredData: ', filteredData);
                        var hoja_detalle = filteredData;
                        var hoja_resumen = responseCache.hoja_resumen;
                        //var { data, total } = responseCache;
                      }
                      //console.log('hoja_detalle: ', hoja_detalle);
                      callback({
                        draw: dataTablesParams.draw,
                        recordsTotal: hoja_detalle.length,
                        recordsFiltered: hoja_detalle.length,
                        data: hoja_detalle,
                      });
                    } catch {
                      callback({
                        draw: dataTablesParams.draw,
                        recordsTotal: 0,
                        recordsFiltered: 0,
                        data: []
                      });
                    }
                  },
                  createdRow: function (row) {
                    $(row).find("td").css({
                      "font-size": "0.85rem",
                      "white-space": "nowrap",
                      "overflow": "hidden",
                      "text-overflow": "ellipsis"
                    });

                    $(row).find("td:last-child").css({
                      "overflow": "visible"
                    });
                  },
                  headerCallback: function(thead, data, start, end, display) {
                    const api = this.api();
                    const $table = $(api.table().container());

                    // Función para contar columnas consecutivas con un prefijo
                    const countSpan = (startIndex, prefix) => {
                      let span = 0;
                      const colCount = api.columns().count();
                      if (prefix == 'gp-end -'){
                        span = 2;
                      }else if (prefix == 'gp-start -'){
                        span = 10;
                      }else if (startIndex == 10){
                        span = 4;
                      }else if (startIndex == 14 || startIndex == 24){
                        span = 10;
                      }
                      //console.log('span: ', span);
                      return span;
                    };

                    // Crear la fila de encabezado agrupado
                    const $groupRow = $('<tr class="group-header"></tr>');
                    const colCount = api.columns().count();
                    let colIndex = 0;

                    while (colIndex < colCount) {
                      const title = api.column(colIndex).header().textContent;
                      let span;
                      let label = "";
                      if (colIndex == 10) {
                        span = countSpan(colIndex, "");
                        label = "Ventas por cuenta de terceros";
                      } else if (colIndex == 14) {
                        span = countSpan(colIndex, "");
                        label = "Contribuyente";
                      } else if (colIndex == 24) {
                        span = countSpan(colIndex, "");
                        label = "No contribuyente";
                      } else if (title == 'I.V.A Retenido' || title == 'I.G.T.F Percibido') {
                        span = countSpan(colIndex, "gp-end -");
                      } else {
                        span = countSpan(colIndex, "gp-start -");
                      }
                      // (2026-05-15) Fix crash DataTables "reading 'bSortable'":
                      // el colspan acumulado de la fila de grupo nunca debe
                      // exceder el total de columnas. Si excede, DataTables
                      // mapea una columna inexistente (aoColumns[idx]=undefined)
                      // y revienta. Se clampa al remanente y se corta si no
                      // queda espacio (evita además bucle infinito si span=0).
                      span = Math.min(Number(span) || 0, colCount - colIndex);
                      if (span <= 0) { break; }
                      $groupRow.append(`<th colspan="${span}" class="text-center border">${label}</th>`);
                      colIndex += span;
                    }

                    // Función para insertar la fila de agrupación en cualquier thead
                    const insertGroupHeader = ($thead) => {
                      // Evitar duplicados
                      if ($thead.find('tr.group-header').length === 0) {
                        $thead.find('tr').first().before($groupRow.clone(true));
                      }
                    };

                    // Insertar en thead principal
                    insertGroupHeader($table.find('.dataTables_scrollHead thead'));

                    // Si hay FixedHeader o multiple thead, insertar también
                    insertGroupHeader($table.find('thead')); // fallback general
                  },
                }}
              />
            </div>
            {(showSummary?.hoja_detalle?.length || 0) > 0 && (
            <div className="w-full px-4 py-4 overflow-x-auto">
              <div class="flex flex-wrap py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Resumen general</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-center">Base imponible</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-center">Débito fiscal</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-center">IVA retenido</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-center">IGTF percibido</h6>
                </div>
              </div>
              <div class="flex flex-wrap border border-top-1 py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Total ventas internas no gravadas</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['01-reg']?.ventas_exentas || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">0,00</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">0,00</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">0,00</h6>
                </div>
              </div>
              <div class="flex flex-wrap border border-top-1 py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Total nota de crédito no gravadas</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['03-reg']?.ventas_exentas || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">0,00</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">0,00</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">0,00</h6>
                </div>
              </div>
              <div class="flex flex-wrap border border-top-1 py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Total nota de débito no gravadas</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['02-reg']?.ventas_exentas || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">0,00</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">0,00</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">0,00</h6>
                </div>
              </div>
              <div class="flex flex-wrap border border-top-1 py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Total ventas internas afectadas sólo alícuota general {formatDecimal(showSummary?.hoja_resumen?.alicuota_general)}%</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['01-reg']?.base_imponible_general || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['01-reg']?.iva_general || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['01-reg']?.iva_retenido_general)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.total_igtf_percibido || 0.0)}</h6>
                </div>
              </div>
              <div class="flex flex-wrap border border-top-1 py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Total ventas internas afectadas sólo alícuota reducida {formatDecimal(showSummary?.hoja_resumen?.alicuota_reducida)}%</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['01-reg']?.base_imponible_reducida || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['01-reg']?.iva_reducida || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['01-reg']?.iva_retenido_reducida)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(0.0)}</h6>
                </div>
              </div>
              <div class="flex flex-wrap border border-top-1 py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Total ventas internas afectadas sólo alícuota adicional {formatDecimal(showSummary?.hoja_resumen?.alicuota_adicional)}%</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['01-reg']?.base_imponible_adicional || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['01-reg']?.iva_adicional || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['01-reg']?.iva_retenido_adicional)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(0.0)}</h6>
                </div>
              </div>
              <div class="flex flex-wrap border border-top-1 py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Total notas de crédito o devoluciones aplicadas en ventas {formatDecimal(showSummary?.hoja_resumen?.alicuota_general)}%</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['03-reg']?.base_imponible_general || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['03-reg']?.iva_general || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['03-reg']?.iva_retenido_general)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(0.0)}</h6>
                </div>
              </div>
              <div class="flex flex-wrap border border-top-1 py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Total notas de crédito o devoluciones aplicadas en ventas {formatDecimal(showSummary?.hoja_resumen?.alicuota_reducida)}%</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['03-reg']?.base_imponible_reducida || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['03-reg']?.iva_reducida || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['03-reg']?.iva_retenido_reducida)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(0.0)}</h6>
                </div>
              </div>
              <div class="flex flex-wrap border border-top-1 py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Total notas de crédito o devoluciones aplicadas en ventas {formatDecimal(showSummary?.hoja_resumen?.alicuota_adicional)}%</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['03-reg']?.base_imponible_adicional || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['03-reg']?.iva_adicional || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['03-reg']?.iva_retenido_adicional)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(0.0)}</h6>
                </div>
              </div>
              <div class="flex flex-wrap border border-top-1 py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Total notas de débito o recargos aplicadas en Ventas {formatDecimal(showSummary?.hoja_resumen?.alicuota_general)}%</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['02-reg']?.base_imponible_general || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['02-reg']?.iva_general || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['02-reg']?.iva_retenido_general)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(0.0)}</h6>
                </div>
              </div>
              <div class="flex flex-wrap border border-top-1 py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Total notas de débito o recargos aplicadas en Ventas {formatDecimal(showSummary?.hoja_resumen?.alicuota_reducida)}%</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['02-reg']?.base_imponible_reducida || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['02-reg']?.iva_reducida || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['02-reg']?.iva_retenido_reducida)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(0.0)}</h6>
                </div>
              </div>
              <div class="flex flex-wrap border border-top-1 py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Total notas de débito o recargos aplicadas en ventas {formatDecimal(showSummary?.hoja_resumen?.alicuota_adicional)}%</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['02-reg']?.base_imponible_adicional || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['02-reg']?.iva_adicional || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_tipo?.['02-reg']?.iva_retenido_adicional)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(0.0)}</h6>
                </div>
              </div>
              <div class="flex flex-wrap border border-top-1 py-1">
                <div class="w-full md:w-4/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold">Total</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(Number(showSummary?.hoja_resumen?.ventas_internas_no_gravadas || 0.0) + Number(showSummary?.hoja_resumen?.base_imponible_general || 0.0) + Number(showSummary?.hoja_resumen?.base_imponible_reducida || 0.0) + Number(showSummary?.hoja_resumen?.base_imponible_adicional || 0.0))}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(Number(showSummary?.hoja_resumen?.iva_general || 0.0) + Number(showSummary?.hoja_resumen?.iva_reducida || 0.0) + Number(showSummary?.hoja_resumen?.iva_adicional || 0.0))}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.total_iva_retenido_periodo || 0.0)}</h6>
                </div>
                <div class="w-full md:w-2/12 px-2">
                  <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.total_igtf_percibido || 0.0)}</h6>
                </div>
              </div>

              {/* (2026-05-21) Desglose propio vs tercero. Solo se muestra
                  cuando el filtro de docs esta en "Todos los docs." y el
                  backend retorna resumen_por_origen. Si el usuario ya esta
                  filtrando por "Solo propio" o "Solo tercero", el desglose
                  resulta redundante (un solo lado tendria datos), por lo que
                  se oculta para evitar confusion. */}
              {docTerceroFilter === "" && showSummary?.hoja_resumen?.resumen_por_origen && (
                <>
                  <div class="flex flex-wrap py-1 mt-4 bg-blueGray-100 rounded-t">
                    <div class="w-full px-2">
                      <h6 className="text-blueGray-800 text-base font-bold py-2">
                        Desglose por origen (propio vs. tercero)
                      </h6>
                    </div>
                  </div>
                  <div class="flex flex-wrap font-semibold text-blueGray-600 border-bottom-1 py-2 bg-blueGray-50">
                    <div class="w-full md:w-4/12 px-2"><h6 className="text-sm">Origen</h6></div>
                    <div class="w-full md:w-1/12 px-2"><h6 className="text-sm text-end"># Docs</h6></div>
                    <div class="w-full md:w-2/12 px-2"><h6 className="text-sm text-end">Exentas</h6></div>
                    <div class="w-full md:w-2/12 px-2"><h6 className="text-sm text-end">Base imponible</h6></div>
                    <div class="w-full md:w-1/12 px-2"><h6 className="text-sm text-end">IVA</h6></div>
                    <div class="w-full md:w-2/12 px-2"><h6 className="text-sm text-end">Total</h6></div>
                  </div>
                  <div class="flex flex-wrap border border-top-1 py-1 bg-sky-50">
                    <div class="w-full md:w-4/12 px-2">
                      <h6 className="text-blueGray-700 text-sm font-bold">
                        <i className="fas fa-building mr-2 text-sky-600"></i>
                        Facturación propia (Empresa)
                      </h6>
                    </div>
                    <div class="w-full md:w-1/12 px-2">
                      <h6 className="text-blueGray-700 text-sm font-bold text-end">{showSummary?.hoja_resumen?.resumen_por_origen?.propio?.cantidad ?? 0}</h6>
                    </div>
                    <div class="w-full md:w-2/12 px-2">
                      <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_origen?.propio?.ventas_exentas || 0.0)}</h6>
                    </div>
                    <div class="w-full md:w-2/12 px-2">
                      <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_origen?.propio?.base_imponible || 0.0)}</h6>
                    </div>
                    <div class="w-full md:w-1/12 px-2">
                      <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_origen?.propio?.iva || 0.0)}</h6>
                    </div>
                    <div class="w-full md:w-2/12 px-2">
                      <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_origen?.propio?.total || 0.0)}</h6>
                    </div>
                  </div>
                  <div class="flex flex-wrap border border-top-1 py-1 bg-amber-50">
                    <div class="w-full md:w-4/12 px-2">
                      <h6 className="text-blueGray-700 text-sm font-bold">
                        <i className="fas fa-handshake mr-2 text-amber-600"></i>
                        Facturación por cuenta de terceros
                      </h6>
                    </div>
                    <div class="w-full md:w-1/12 px-2">
                      <h6 className="text-blueGray-700 text-sm font-bold text-end">{showSummary?.hoja_resumen?.resumen_por_origen?.tercero?.cantidad ?? 0}</h6>
                    </div>
                    <div class="w-full md:w-2/12 px-2">
                      <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_origen?.tercero?.ventas_exentas || 0.0)}</h6>
                    </div>
                    <div class="w-full md:w-2/12 px-2">
                      <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_origen?.tercero?.base_imponible || 0.0)}</h6>
                    </div>
                    <div class="w-full md:w-1/12 px-2">
                      <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_origen?.tercero?.iva || 0.0)}</h6>
                    </div>
                    <div class="w-full md:w-2/12 px-2">
                      <h6 className="text-blueGray-700 text-sm font-bold text-end">{formatDecimal(showSummary?.hoja_resumen?.resumen_por_origen?.tercero?.total || 0.0)}</h6>
                    </div>
                  </div>
                  {Number(showSummary?.hoja_resumen?.resumen_por_origen?.facturas_combinada_con_servicio || 0) > 0 && (
                    <div class="flex flex-wrap py-1 px-2 text-xs text-blueGray-500 italic">
                      <i className="fas fa-info-circle mr-1"></i>
                      {showSummary.hoja_resumen.resumen_por_origen.facturas_combinada_con_servicio} factura(s)
                      Combinada con cobro de servicio (la comisión se contabiliza en "Propio").
                    </div>
                  )}
                </>
              )}
            </div>
            )}
          </div>
        </div>
      </div>
    </div>

  );
}

export default SalesBook;